<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">Beating the Nazi Invader</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?cce7bfae